import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import premiumForm from './premiumForm';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { premiumTemplateResource, premiumTemplateStore } from './../request';
import { structureList } from '@/views/customer/accountManage/request';
export default {
  components: {
    topTitle,
    premiumForm
  },
  data() {
    return {
      activeKey: [],
      premiumTemplateList: [],
      dataFrom: {},
      dialogVisible: false,
      structureLists: [],
      insurancePlanId: '',
      customerInsuranceId: ''
    };
  },
  methods: {
    async init(customerInsuranceId, insurancePlanId, customerId) {
      this.insurancePlanId = insurancePlanId;
      this.customerInsuranceId = customerInsuranceId;
      this.dataFrom = await premiumTemplateResource({
        customerInsuranceId: customerInsuranceId,
        insurancePlanId: insurancePlanId
      });
      const res = await structureList({
        customerId: customerId
      });
      if (this.dataFrom.priceType == 'AREA_PRICE') {
        this.premiumTemplateList = recursionCopy(this.dataFrom.areaConfig);
      } else {
        this.premiumTemplateList = recursionCopy(this.dataFrom.premiumTemplateList);
      }
      res[0].name = this.$t('全部');
      this.structureLists = res;
      let arr = [];
      this.premiumTemplateList.forEach(i => {
        if (this.dataFrom.priceType === 'AREA_PRICE') {
          i.premiumTemplateList.forEach(i2 => {
            arr = arr.concat(i2.structureIds);
          });
        } else {
          i.structureIds.forEach(i2 => {
            arr = arr.concat(i2.structureIds);
          });
        }
      });
      if (arr[0] == 0) {
        this.structureLists = this.traverseTree2(this.structureLists);
      } else {
        this.structureLists = this.traverseTree(this.structureLists, arr);
        this.structureLists[0].disabled = arr.length > 0 ? true : false;
      }
      this.dialogVisible = true;
    },
    traverseTree(tree, arr) {
      tree.forEach(i => {
        const num = arr.findIndex(item => item == i.id);
        i.disabled = num != -1 ? true : false;
        i.children && this.traverseTree(i.children, arr);
      });
      return tree;
    },
    traverseTree2(tree) {
      tree.forEach(i => {
        i.disabled = true;
        i.children && this.traverseTree2(i.children);
      });
      return tree;
    },
    handleEdit(index) {
      this.premiumTemplateList[index].isEdit = true;
      console.log(index, this.premiumTemplateList[index]);
      this.premiumTemplateList.splice(index, 1, this.premiumTemplateList[index]);
    },
    handleTree(num, array, num2) {
      if (array[0] == 0) {
        this.structureLists = this.traverseTree2(this.structureLists);
      } else {
        let arr = [];
        if (this.dataFrom.priceType == 'AREA_PRICE') {
          this.premiumTemplateList.forEach((i, index) => {
            if (num != index) {
              i.premiumTemplateList.forEach(i2 => {
                arr = arr.concat(i2.structureIds);
              });
            }
          });
        } else {
          this.premiumTemplateList.forEach((i, index) => {
            if (num2 != index) {
              arr = arr.concat(i.structureIds);
            }
          });
        }
        arr = arr.concat(array);
        this.structureLists = this.traverseTree(this.structureLists, arr);
        this.structureLists[0].disabled = arr.length > 0 ? true : false;
      }
    },
    handleCancel(index) {
      let arr = [];
      this.premiumTemplateList.forEach(i => {
        i.premiumTemplateList.forEach(i2 => {
          arr = arr.concat(i2.structureIds);
        });
      });
      if (arr[0] == 0) {
        this.structureLists = this.traverseTree2(this.structureLists);
      } else {
        this.structureLists = this.traverseTree(this.structureLists, arr);
        this.structureLists[0].disabled = arr.length > 0 ? true : false;
      }
      this.premiumTemplateList[index].isEdit = false;
      this.premiumTemplateList.splice(index, 1, this.premiumTemplateList[index]);
    },
    async handleSave(index, arr) {
      let templateConfig = [];
      arr.map(item => {
        templateConfig.push({
          discountMode: item.discountMode,
          discountRatio: item.discountRatio || 0,
          discountAmount: item.discountAmount || 0,
          structureIds: item.structureIds
        });
      });
      const areaIndex = this.dataFrom.priceType == 'AREA_PRICE' ? this.premiumTemplateList[index].areaIndex : 0;
      await premiumTemplateStore({
        customerInsuranceId: this.customerInsuranceId,
        insurancePlanId: this.insurancePlanId,
        areaIndex: areaIndex,
        templateConfig: templateConfig
      });
      const {
        areaConfig,
        priceType
      } = await premiumTemplateResource({
        customerInsuranceId: this.customerInsuranceId,
        insurancePlanId: this.insurancePlanId
      });
      this.$message.success(this.$t('保存成功'));
      if (priceType == 'AREA_PRICE') {
        let arr = recursionCopy(areaConfig);
        arr[index].isEdit = false;
        this.premiumTemplateList.splice(index, 1, arr[index]);
        console.log(this.premiumTemplateList);
        // this.premiumTemplateList =
      } else {
        this.$emit('cancel');
      }
    }
  }
};